// extracted by mini-css-extract-plugin
export default {"container":"customcontainer_container__3LFwc","containerChild":"customcontainer_containerChild__4WWmp"};